import { Phone } from 'lucide-react';
import { SW_PHONE_DISPLAY, SW_PHONE_RAW } from '../config';

export default function SwCallBar() {
  return (
    <div className="swp-callbar" role="region" aria-label="Call the booking desk">
      <a href={`tel:${SW_PHONE_RAW}`}>
        <span className="swp-callbar__icon">
          <Phone size={28} strokeWidth={2.4} aria-hidden />
        </span>
        <span className="swp-callbar__copy">
          <small>Save Time &amp; Get the Best Flight Deals</small>
          <strong>{SW_PHONE_DISPLAY}</strong>
        </span>
      </a>
    </div>
  );
}
